module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Import reviews","submit":"Save"}}')
  delete Component.options._Ctor
}
